<template>
    <div>
        <loading></loading>
    </div>
</template>


<script>
import { reset } from 'js/vuex/actions'
import { logout } from 'js/api/auth'
import track from 'js/helpers/analytics'
import notify from 'js/components/notifications/notificationsMixin'
import Loading from 'js/components/elements/Loading.vue'

export default {
    name: 'Logout',
    mixins: [ notify ],
    components: { Loading },
    vuex: {
        actions: { reset }
    },
    beforeRouteEnter: (to, from, next) => {

        // protect against outside links to logout
        if ( to.params._internal !== true ) {
            return next({ name: 'root' })
        }

        next( vm => {

            // reset vuex data
            vm.reset()

            track.user(null)

            // destroy tokens
            logout().then( () => {

                if ( to.query.next === 'web' ) {
                    window.location.replace('/')
                } else {
                    vm.$router.replace({ name: 'login' })
                }
            })

        })

    },
}
</script>

<style lang="scss">
    @import 'global';
</style>



// WEBPACK FOOTER //
// Logout.vue?aeb14434